import { Loader2 } from "lucide-react";
import React from "react";

export default function Loader() {
  return (
    <div className="flex flex-col items-center gap-3">
      <Loader2 className="w-10 h-10 text-green-600 animate-spin" />
      <p className="text-sm text-gray-500">Chargement...</p>
    </div>
  );
}
